<button
  [id]="id"
  type="button"
  [title]="title"
  [type]="type"
  [class]="getButtonClasses()"
  [disabled]="disabled"
  [style.color]="getColor()"
  >
  @if (icon) {
    <app-icon [name]="icon" [color]="getColor()"></app-icon>
  }
  <ng-content></ng-content>
</button>
